import { QRCodeSVG } from 'qrcode.react';
import { useTranslation } from '../../../../lib/i18n';
import { useProductName } from '../../../../lib/use-brand';
import { useGenericBi } from '../../../../lib/use-generic-bi';
import { phonePhotoHandoffLink } from '../../../../lib/phone-photo-handoff';
import { Modal } from '../../../Modal';
import { Button, Card, Typography } from '../../ui';
import styles from './PhonePhotoDialog.module.css';

const QR_SIZE = 180;

// The scan target behind the desktop composer's "Photo from your phone" row (see lib/phone-photo-handoff).
// It opens THIS conversation on the phone with its camera up, so the photo lands in the chat on screen
// rather than in whichever chat the phone happened to open — which is what "the web and the app are not
// in sync" was really reporting.
//
// No native counterpart, deliberately: the phones ARE the camera, and their composer already offers it.
export function PhonePhotoDialog({ conversationId, onClose }: { conversationId: string; onClose: () => void }) {
  const { t } = useTranslation();
  const productName = useProductName();
  const { logModalActionBi } = useGenericBi();
  const close = () => {
    logModalActionBi({ page_name: 'chat', modal_name: 'phone_photo', action: 'close' });
    onClose();
  };
  return (
    <Modal
      open
      onClose={close}
      width={440}
      maxHeightPx={650}
      scrollBody
      title={t('chat.phonePhoto.title')}
      labelledBy="phone-photo-title"
      footer={<Button onClick={close}>{t('common.close')}</Button>}
    >
      <div className={styles.body}>
        <Typography variant="p2" color="primary" component="p">
          {t('chat.phonePhoto.body', { productName })}
        </Typography>
        <Card variant="sunken" size="sm" disablePadding className={styles.qrPanel}>
          {/* Black-on-white in both themes, as on the install card: an inverted code is refused by many scanners. */}
          <QRCodeSVG
            value={phonePhotoHandoffLink(conversationId)}
            size={QR_SIZE}
            level="M"
            marginSize={0}
            bgColor="var(--ds-white)"
            fgColor="var(--ds-black)"
            title={t('chat.phonePhoto.qrAlt')}
          />
        </Card>
      </div>
    </Modal>
  );
}
